import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { RunplanTracklibrariesService } from './runplan-tracklibraries.service';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { DatePipe } from '@angular/common';
import { Table } from 'primeng/table';
import { MasterDataService } from '../masterdata/masterdata.service';
import {  RunPlanTrackLibrariesUpdateDTO, TrackLibrariesUpdateHistory } from './runplan_trackLibrariesDTO';
import { UPDATE_STATUS_OPTION, UPDATE_SEQUENCING_STEPS_OPTION, UPDATE_CONSTRAINTS_OPTION, UPDATE_MISSINGREADS_OPTION, UPDATE_RAW_DATA_DELIVERY_DATE } from '../runplan-mainview/models/runPlanConstants';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-runplan-tracklibraries',
  templateUrl: './runplan-tracklibraries.component.html',
  styleUrls: ['./runplan-tracklibraries.component.css']
})
export class RunplanTracklibrariesComponent implements OnInit {

  @ViewChild('topDiv',{static : false}) elementView: ElementRef;
  errorHandler: ErrorHandler = new ErrorHandler;

  @ViewChild('dt',{static : true}) table: Table;

  selectedLabId: string;
  searchStatusList: any[] = [];
  actionList: any[] = [];
  puid: string;
  valueToSearchforStatus: any[];
  valueToSearchforAction:string;
  statusfromDate: Date;
  statustoDate: Date;
  statustoDateForRawDataDelivery: Date;
  updateRawDataDeliveryDate: string;
  blocked: boolean = false;
  loading: boolean = false;
  scrollableCols: any[];
  runTrackLibrariesValsTotalRows: any[]=[];
  runTrackLibrariesPagination :any[]=[];
  runTrackLibrariesPaginationDuplicate:any[]=[];
  customerNameMap = new Map<string, string>();
  setRowdataforAction:any[] = [];
  listofLibraries:any[] = [];
  isSelected = false;
  actionUpdateFlag : boolean = false;
  constraintTypeOptions: any[] = [];
  selectedConstraintType: string;
  enteredConstraintId: string;
  showinputOnLoad: boolean = true;
  productIdsOptions: any[] = [];
  constraintValidationList: any[]=[];
  listOfTrackLibraries:any[] = [];
  truncateStr ='. . .';
  lastIndexofTrackLib : string;
  truncateBooleanFlag : boolean = false;
  listofLibrariesWithoutTruncate:any[] = [];
  runPlanTrackFilterValue:any;
  enteredMissingReads: any;
  modifiedActionUpdate: RunPlanTrackLibrariesUpdateDTO[];
  actionTypeMessage: string;
  listOfTagUntagStr:any[] = [];
  tagCount:number = 0;
  untagCount:number = 0;
  flowCellMapwithCapabilties = new Map<string, any[]>();
  capabilityModeOptions: any[];
  selectedCapabilityMode: any;
  capabilityLength: number;
  sequencerOptions:any[] = [];
  selectedSequencerType: string = null;
  rowsCount : any = 0;
  erroMessageAfterUpdateFailed = '';
  selectedLab: any;
  dateFormat: string;
  statusCountForValidation: boolean;
  private readonly dateFormatForYYYYMMDD = "yyyy-MM-dd";

  constructor(private _messagesService: MessagesService, private runPlantrackservice: RunplanTracklibrariesService,
    private datepipe: DatePipe,  private masterdataService: MasterDataService, private confirmationService: ConfirmationService) { }

    setDateFormat(dateFormat){
      return   dateFormat.length>8  ? dateFormat.replace("yyyy","yy"): dateFormat.replace("yy","y");
    } 
  ngOnInit() {
    this.selectedLab = JSON.parse(localStorage.getItem('lab')).lab
    this.selectedLabId = this.selectedLab._id;
    this.dateFormat =this.setDateFormat(this.selectedLab.dateFormat.toLowerCase());
    this.puid = localStorage.getItem('PUID');
    this.scrollableTableColumn();

    this.searchStatusList = [
      { label: 'Plannable', value: "PLANNABLE" },
      { label: 'Planned', value: "PLANNED" },
      { label: 'Sequencing/Analysis', value: "SEQUENCING/ANALYSIS" },
      { label: 'Completed', value: "COMPLETED" },
      { label: 'DiscussResults/RedoLib', value: "DISCUSSRESULTS/REDOLIB" },
      { label: 'Cancelled', value: "CANCELLED" },
      { label: 'Other', value: "OTHER" },
      
    ];

    this.actionList = [
      { label: 'Update run constraints', value: "UPDATE_CONSTRAINTS" },
      { label: 'Update express status', value: "UPDATE_STATUS" },
      { label: 'Update missing reads', value: "UPDATE_MISSINGREADS" },
      { label: 'Update sequencing specs', value: "UPDATE_SEQUENCE" },
      { label: 'Update raw data delivery date', value: "UPDATE_RAW_DATA_DELIVERY_DATE" }
    ];

    this.constraintTypeOptions = [
      { 'label': 'Independent', 'value': 'independent' },
      { 'label': 'Product', 'value': 'product' },
      { 'label': 'Batch-wise', 'value': 'batch' },
      { 'label': 'Exclusive', 'value': 'exclusive' }
    ];

    this.capabilityModeOptions = [
      {label: "PE", name:"PE"},
      {label: "SR", name:"SR"}
    ];
    this.valueToSearchforStatus = this.searchStatusList.filter(type => ['PLANNABLE'].includes(type.value))
    this.statusfromDate = this.getDefaultDate(new Date(), 0);
    this.statustoDate = this.getDefaultDate(new Date(), +28);
    this.statustoDateForRawDataDelivery = this.getDefaultDate(new Date(), 0);
  
    this.onApplyFilter();
  }
  getDefaultDate(date: Date, delta: number) {
    date.setDate(date.getDate() + delta);
    return date;
  }
  onApplyFilter() {
    if(this.statusfromDate == null) {
      this._messagesService.addErrorMessage({severity: 'error', summary: 'From date cannot be empty'});
      return;
    }
    if(this.statustoDate != null && this.statusfromDate > this.statustoDate) {
      this._messagesService.addErrorMessage({severity: 'error', summary: 'From date cannot be greater than To date'});
      return;
    }
    this.table.reset();
    let requestObj = {};
    requestObj['labId'] = this.selectedLabId;
    requestObj['selectedStatus'] = this.valueToSearchforStatus == null ? [] : this.valueToSearchforStatus.map(lib => lib.value);
    requestObj['fromDate'] = this.datepipe.transform(this.statusfromDate.toUTCString(), this.dateFormatForYYYYMMDD);
    requestObj['toDate'] = this.statustoDate!=null?this.datepipe.transform(this.statustoDate.toUTCString(), this.dateFormatForYYYYMMDD):null;
    this.blocked = true;
    this.runTrackLibrariesValsTotalRows = [];
    this.runTrackLibrariesPagination= [];
    this.runTrackLibrariesPaginationDuplicate=[];
    this.listofLibrariesWithoutTruncate = [];
    this.setRowdataforAction=[];
    this.isSelected=false;
    this.actionUpdateFlag=false;
    this.valueToSearchforAction='';
    this.runPlanTrackFilterValue ='';
    this.runPlantrackservice.getListOfPlannableLibrariesData(requestObj).subscribe(
      result => {
        if (result.data && result.data.librariesList) {
          this.runTrackLibrariesValsTotalRows=result.data.librariesList;
          this.runTrackLibrariesPagination=result.data.librariesList.slice(0, 250);
          this.rowsCount=this.runTrackLibrariesPagination.length;
          this.runTrackLibrariesPaginationDuplicate=result.data.librariesList.slice(0, 250);
          this.customerNameMap = result.data.mapOfCustomerData ? new Map(Object.entries(result.data.mapOfCustomerData)) : null;
          this.sortDueDateRawData();
        }else{
          this.blocked = false;
          this._messagesService.addErrorMessage({severity: 'warn', summary: 'RunPlan Track Libraries data not found'});
          return;
        }
        this.blocked = false;
      },
      error => {
        this.handleError(error);
      });
  }

  private sortDueDateRawData() {
    this.runTrackLibrariesPagination.sort((lib1, lib2) => {
      let dateA: any;
      let dateB: any;
      dateA = lib1['dueDateRawData'] && lib1['dueDateRawData']['$date'] ? new Date(lib1['dueDateRawData']['$date']).getTime() : '';
      dateB = lib2['dueDateRawData'] && lib2['dueDateRawData']['$date'] ? new Date(lib2['dueDateRawData']['$date']).getTime() : '';
      return dateA - dateB;
    });
  }

  private handleError(error: any) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  customSort(event: any) {
    let compResult = null;
    if(event.field === 'customer'){
      event.data.sort((lib1: any, lib2: any) => {
        let libData1 = this.customerNameMap.get(lib1['projectName']) ? this.customerNameMap.get(lib1['projectName']) : '';
        let libData2 = this.customerNameMap.get(lib2['projectName'])  ? this.customerNameMap.get(lib2['projectName'])  : '';
        compResult = this.getSortResult(libData1, libData2);
        return (event.order * compResult);
      });
    }else if(event.field === 'dueDateRawData'){
      if (event.order == 1) {
        event.data.sort((lib1, lib2) => {
          let dateA:any
          let dateB:any
           dateA = lib1[event.field] && lib1[event.field]['$date'] ? new Date(lib1[event.field]['$date']).getTime() : '';
          dateB = lib2[event.field] && lib2[event.field]['$date'] ? new Date(lib2[event.field]['$date']).getTime(): '' ;
          return dateB - dateA;
        })
      }else{
        event.data.sort((lib1, lib2) => {
          let dateA:any
          let dateB:any
           dateA = lib1[event.field] && lib1[event.field]['$date'] ? new Date(lib1[event.field]['$date']).getTime() : '' ;
          dateB = lib2[event.field] && lib2[event.field]['$date'] ? new Date(lib2[event.field]['$date']).getTime(): '';
          return dateA - dateB;
        })
      }
    }else if(event.field === 'runLaneInfoHistory'){
      event.data.sort((libsData1: any, libsData2: any) => {
        let lib1 = libsData1.maxRunId ? libsData1.maxRunId: '';
        let lib2 = libsData2.maxRunId ? libsData2.maxRunId : '';
        compResult = this.getSortResult(lib1, lib2);
        return (event.order * compResult);
      });
    } else if(event.field == 'platePosition') {
      event.data.sort((libsData1: any, libsData2: any) => {
        if(libsData1.platePosition == 'N/A') 
          return (event.order * 1);
        else if(libsData2.platePosition == 'N/A')
          return (event.order * -1);
        else {
          let lib1Position = libsData1.platePosition
          let lib2Position = libsData2.platePosition
          
          let sortResult = this.sortLibrariesByPlatePosition(lib1Position, lib2Position)
          return (event.order * sortResult);
        }
      })
    } else if(event.field == 'plateBarcode')  {
        event.data.sort((lib1: any, lib2: any) => {
          if(lib1.plateBarcode == 'N/A')
            return (event.order * 1);
          else if(lib2.plateBarcode == 'N/A')
            return (event.order * -1);
          else {
            compResult = this.getSortResult(lib1.plateBarcode, lib2.plateBarcode);
            return (event.order * compResult);
          }
        })
    } else{
      event.data.sort((lib1: any, lib2: any) => {
        let libData1 = lib1[event.field] ? lib1[event.field] : '';
        let libData2 = lib2[event.field] ? lib2[event.field] : '';
        compResult = this.getSortResult(libData1, libData2);
        return (event.order * compResult);
      });
    }
  }

  sortLibrariesByPlatePosition(lib1Position: any, lib2Position: any) {
    let lib1Col = Number(lib1Position.substring(1))
    let lib1Row = lib1Position.substring(0,1)
    let lib2Col = Number(lib2Position.substring(1))
    let lib2Row = lib2Position.substring(0,1)

    if(lib1Col < lib2Col) {
      return -1
    } else if(lib1Col > lib2Col) {
      return 1
    } else if(lib1Row < lib2Row) {
        return -1
    } else if(lib1Row > lib2Row) {
        return 1
    } else {
        return 0
    }
  }

  getStyle(field) {
    if (field == "checkbox") {
      return { width: '7rem', height: '2.6rem' };
    } else if(field == "runspecs"){
      return { width: '11rem', height: '2.6rem' };
    }else{
      return { width: '10rem', height: '2.6rem' };
    }
  }

  getCustomerNameFromMap(projectName: string) {
    if(this.customerNameMap.get(projectName)){
      return this.customerNameMap.get(projectName);
    }else{
      return '-';
    }
  }
  getDate(date: any) {
    if(date) {
      return this.datepipe.transform(date['$date'], 'dd.MM.yy');
    }
    return null;
  }

  getTextCellValue(field: string, rowData: any){
    if(rowData[field] && field != 'customer' && field != 'dueDateRawData' && field != 'missingReads') {
      return rowData[field];
    }else if(field === 'customer'){
      return this.customerNameMap && this.customerNameMap.get(rowData['projectName']) ? this.customerNameMap.get(rowData['projectName']):'-';
    }else if (rowData[field] && field === 'dueDateRawData'){
      return this.datepipe.transform(rowData.dueDateRawData['$date'], this.selectedLab.dateFormat);
    }else{
      return '-';
    }
  }

  getSortResult(value1, value2) {
    if (value1 < value2) {
      return -1;
    }
    return (value1 > value2) ? 1 : 0;
  }
  clearTableData(){
    this.valueToSearchforStatus =[];
    this.setRowdataforAction=[];
    this.listofLibrariesWithoutTruncate = [];
    this.isSelected=false;
    this.listOfTrackLibraries=[];
    this.selectedConstraintType = '';
    this.enteredConstraintId = '';
    this.constraintValidationList =[];
    this.truncateBooleanFlag = false;
    this.lastIndexofTrackLib ='';
    this.actionTypeMessage ='';
    this.tagCount=0;
    this.untagCount=0;
    this.enteredMissingReads ='';
    this.valueToSearchforAction='';
    this.runPlanTrackFilterValue ='';
    this.selectedSequencerType  = '';
    this.selectedCapabilityMode ='';
    this.capabilityLength=null;
    this.actionUpdateFlag=false;
    this.valueToSearchforStatus = this.searchStatusList.filter(type => ['PLANNABLE'].includes(type.value))
    this.statusfromDate = this.getDefaultDate(new Date(), 0);
    this.statustoDate = this.getDefaultDate(new Date(), +28);
    this.runTrackLibrariesPagination=[];
    this.runTrackLibrariesPaginationDuplicate=[];
    this.onApplyFilter();
  }
  applyOnchangeFilterCheck(){
    if(this.valueToSearchforStatus.length == 0){
      this.runTrackLibrariesValsTotalRows=[];
      this.runTrackLibrariesPagination=[];
      this.runTrackLibrariesPaginationDuplicate=[];
      this.listofLibrariesWithoutTruncate = [];
      this.setRowdataforAction=[];
      this.listOfTrackLibraries=[];
      this.isSelected=false;
      this.selectedConstraintType = '';
      this.enteredConstraintId = '';
      this.constraintValidationList =[];
      this.truncateBooleanFlag = false;
      this.lastIndexofTrackLib ='';
      this.actionTypeMessage ='';
      this.tagCount=0;
      this.untagCount=0;
      this.selectedSequencerType  = '';
      this.selectedCapabilityMode ='';
      this.capabilityLength=null;
      this.actionUpdateFlag=false;
    }
  }

  getcheckBoxData(data:any,event:any){
      if(data && !this.actionUpdateFlag){
        if(event){
         this.setRowdataforAction.push(data);
        }else{
          data.checkbox=false;
          let index = this.setRowdataforAction.findIndex(x => x.libraryId === data.libraryId);
          if(index != -1) {
            this.setRowdataforAction.splice(index,1);
          }
          this.setRowdataforAction=this.setRowdataforAction.filter(
            (element, i) => i === this.setRowdataforAction.indexOf(element)
          );
          this.isSelected=false;
        }
        this.checkForAllRowselected();
      }
  }
  checkForAllRowselected() {
    if (this.runTrackLibrariesPagination.every((element)=> element.checkbox)) {
      this.isSelected = true;
    } else {
      this.isSelected = false;
    }
  }

  getcheckBoxDataforAllRow(event:any){
    if(this.isSelected){
     this.setRowdataforAction=[];
     this.runTrackLibrariesPagination.forEach (trackLib => {
       if(trackLib.libraryId){
        trackLib.checkbox=true
         this.getcheckBoxData(trackLib,event)
       }
      })
    }else{
     this.runTrackLibrariesPagination.forEach (checkValue => {
       checkValue.checkbox=false
     })
     this.isSelected=false
     this.setRowdataforAction=[];
    }
  }

  setActionsUpdate(){
   this.selectedConstraintType = '';
   this.enteredConstraintId = '';
   this.enteredMissingReads ='';
   this.constraintValidationList =[];
   this.listOfTrackLibraries=[];
   let statusCount=0
   let onholdstatusCount=0
   let listOfProjectName=[];
   this.listofLibrariesWithoutTruncate=[];
   this.truncateBooleanFlag = false;
   this.lastIndexofTrackLib ='';
   this.actionTypeMessage ='';
   this.tagCount=0;
   this.untagCount=0;
   this.selectedSequencerType  = '';
   this.selectedCapabilityMode ='';
   this.capabilityLength=null;
   this.erroMessageAfterUpdateFailed = '';
   this.setRowdataforAction=this.setRowdataforAction.filter(
    (element, i) => i === this.setRowdataforAction.indexOf(element)
  );

  if (['UPDATE_CONSTRAINTS','UPDATE_STATUS'].includes(this.valueToSearchforAction)){
    this.setListForUpdatingConstraints(statusCount, onholdstatusCount, listOfProjectName);
  } else if(['UPDATE_MISSINGREADS','UPDATE_SEQUENCE','UPDATE_RAW_DATA_DELIVERY_DATE'].includes(this.valueToSearchforAction)){
    this.setListForMissingReadsUpdate(statusCount);
  } 
    this.setListForTruncatingView();
    this.actionUpdateFlag=true;
    this.setTableColumnandApiCall();
  }



  setTableColumnandApiCall() {
    if (['UPDATE_CONSTRAINTS'].includes(this.valueToSearchforAction)) {

      this.getListOfProductsIdFromMDM();
      this.scrollableCols = [
        { 'header': 'Library Id', 'field': 'libraryId', 'selected': false },
        { 'header': 'Plate BC', 'field': 'plateBarcode', 'selected': false },
        { 'header': 'Sample Name', 'field': 'sampleName', 'selected': false },
        { 'header': 'Project', 'field': 'projectName', 'selected': false },
        { 'header': 'Customer', 'field': 'customer', 'selected': false },
        { 'header': 'Raw Data Due Date', 'field': 'dueDateRawData', 'selected': false },
        { 'header': 'Constraint', 'field': 'constraint', 'selected': false }
      ];

    } else if (['UPDATE_STATUS'].includes(this.valueToSearchforAction)) {

      this.scrollableCols = [
        { 'header': 'Library Id', 'field': 'libraryId', 'selected': false },
        { 'header': 'Plate BC', 'field': 'plateBarcode', 'selected': false },
        { 'header': 'Sample Name', 'field': 'sampleName', 'selected': false },
        { 'header': 'Project', 'field': 'projectName', 'selected': false },
        { 'header': 'Customer', 'field': 'customer', 'selected': false },
        { 'header': 'Raw Data Due Date', 'field': 'dueDateRawData', 'selected': false },
        { 'header': 'Express', 'field': 'highPriority', 'selected': false }
      ];

    } else if (['UPDATE_MISSINGREADS'].includes(this.valueToSearchforAction)) {

      this.scrollableCols = [
        { 'header': 'Library Id', 'field': 'libraryId', 'selected': false },
        { 'header': 'Plate BC', 'field': 'plateBarcode', 'selected': false },
        { 'header': 'Sample Name', 'field': 'sampleName', 'selected': false },
        { 'header': 'Project', 'field': 'projectName', 'selected': false },
        { 'header': 'Customer', 'field': 'customer', 'selected': false },
        { 'header': 'Raw Data Due Date', 'field': 'dueDateRawData', 'selected': false },
        { 'header': 'Required Reads', 'field': 'missingReads', 'selected': false }
      ];

    } else if (['UPDATE_SEQUENCE'].includes(this.valueToSearchforAction)) {

      this.scrollableCols = [
        { 'header': 'Library Id', 'field': 'libraryId', 'selected': false },
        { 'header': 'Plate BC', 'field': 'plateBarcode', 'selected': false },
        { 'header': 'Sample Name', 'field': 'sampleName', 'selected': false },
        { 'header': 'Project', 'field': 'projectName', 'selected': false },
        { 'header': 'Customer', 'field': 'customer', 'selected': false },
        { 'header': 'Raw Data Due Date', 'field': 'dueDateRawData', 'selected': false },
        { 'header': 'Sequencing Specs', 'field': 'runspecs', 'selected': false }
      ];
      this.getMapOfFlowcellWithCapabilities();
      this.getSequencerFromMachine();

    }
  }

  setListForMissingReadsUpdate(statusCount: number) {
    this.updateRawDataDeliveryDate = null;
    this.statusCountForValidation = false;
    this.setRowdataforAction.forEach(lib => {
      if (this.getcheckForMissingReads(lib)) {
        statusCount = (lib.statusType == 'NOTSTANDBY') || (lib.statusType == 'PLANNED') ? statusCount + 1 : statusCount;
      } else {
        this.listofLibrariesWithoutTruncate.push(lib);
      }

      if('others' === lib.statusType) {
        statusCount = statusCount+1;
      }

    });
    if (statusCount > 0) {
      this.constraintValidationList.push(`Update is rejected for <b>  ${statusCount}  </b>libraries as they have another status than plannable`);
      this.statusCountForValidation = true; 
    } 
    if(['UPDATE_MISSINGREADS'].includes(this.valueToSearchforAction)){
      this.actionTypeMessage = `According to your selection, BB is going to update the missing reads of following  <b> ${this.listofLibrariesWithoutTruncate.length}</b> libraries :`;
    }else if(['UPDATE_SEQUENCE'].includes(this.valueToSearchforAction)){
      this.actionTypeMessage = `According to your selection, BB is going to update the sequencing specification of following  <b> ${this.listofLibrariesWithoutTruncate.length} </b> libraries :`;
    }else if(['UPDATE_RAW_DATA_DELIVERY_DATE'].includes(this.valueToSearchforAction)){
      this.actionTypeMessage = `According to your selection, BB is going to update the delivery date of following  <b> ${this.listofLibrariesWithoutTruncate.length}  </b> libraries :`;
    } 
  }
  getcheckForMissingReads(lib){
    return 'PLANNABLE'!== lib.statusType;
  }
  
   setListForUpdatingConstraints(statusCount: number, onholdstatusCount: number, listOfProjectName: any[]) {
    this.setRowdataforAction.forEach(lib => {
      if (this.getcheckForMissingReads(lib)) {
        statusCount = (lib.statusType === 'NOTSTANDBY') || (lib.statusType === 'PLANNED') ? statusCount + 1 : statusCount;
      } else {
        this.listofLibrariesWithoutTruncate.push(lib);
      }
      if('others' === lib.statusType) {
        statusCount = statusCount+1;
      }

    });
   
    if(['UPDATE_CONSTRAINTS'].includes(this.valueToSearchforAction)){
      this.actionTypeMessage = 'According to your selection, BB is going to update the run constraint of following <b>' + this.listofLibrariesWithoutTruncate.length + ' </b> libraries :';
    }else{
      this.actionTypeMessage = 'According to your selection, BB is going to';
      this.getLibToTagUntag();
    }
    
    this.setNoticeStringIntoList(statusCount, onholdstatusCount, listOfProjectName);
  }

  getLibToTagUntag(){
    let tagStr='';
    let unTagStr='';
    this.listOfTagUntagStr = [];
    this.tagCount=0;
    this.untagCount=0;
    this.listofLibrariesWithoutTruncate.forEach(librow => {
      if(librow.highPriority == 'no'){
        this.tagCount++;
      }else{
        this.untagCount++;
      }      
    });
      tagStr = "flag <b>"+this.tagCount+"</b> libraries";
      unTagStr = "unflag <b>"+this.untagCount+"</b> libraries";
      if(this.tagCount>0){
        this.listOfTagUntagStr.push(tagStr);
      }
      if(this.untagCount>0){
        this.listOfTagUntagStr.push(unTagStr);
      }
   }
  
   setNoticeStringIntoList(statusCount,onholdstatusCount,listOfProjectName){
    if(onholdstatusCount > 0 && this.valueToSearchforAction == 'UPDATE_CONSTRAINTS'){
      this.constraintValidationList.push(`Update is rejected for <b> ${onholdstatusCount} </b>libraries as they are part of on hold project(s): ${listOfProjectName}. Please use the on hold list to release these libraries.`);
    }
    if(onholdstatusCount > 0 && this.valueToSearchforAction == 'UPDATE_STATUS'){
      this.constraintValidationList.push(`Update is rejected for <b> ${onholdstatusCount} </b>libraries as they are part of on hold project(s): ${listOfProjectName}. Please use the on hold list to release these libraries, before you update the express flag.`);
    }
    if(statusCount > 0){
      this.constraintValidationList.push(`Update is rejected for <b> ${statusCount} </b>libraries as they have another status than "plannable" `);
    }
   }

   setListForTruncatingView(){
    for(let i = 0; i < this.listofLibrariesWithoutTruncate.length; i++) {
      if(i <= 14){
        this.listOfTrackLibraries.push(this.listofLibrariesWithoutTruncate[i]);
      }else if(i > 14 && i < this.listofLibrariesWithoutTruncate.length -1){
        this.truncateBooleanFlag =true;
      }else if (i == this.listofLibrariesWithoutTruncate.length -1){
        let value=this.listofLibrariesWithoutTruncate[this.listofLibrariesWithoutTruncate.length -1];
        this.lastIndexofTrackLib=value.libraryId+" ("+value.projectName+")";
      }
    }
    this.listOfTrackLibraries.sort((d1, d2) => {
    if (d1.libraryId < d2.libraryId)
      return -1;
    else if (d1.libraryId > d2.libraryId)
      return 1;
    else
      return 0;
    });
   }

  getListOfProductsIdFromMDM() {
    this.productIdsOptions = []
    this.blocked = true;
    this.masterdataService.getProductIdsFromMDM(this.selectedLabId).subscribe(
      result => {
        if (result.data) {
          result.data.forEach(productId => {
            this.productIdsOptions.push({ label: productId, value: productId });
          });
          this.productIdsOptions.sort((d1, d2) => {
            if (d1.value < d2.value)
              return -1;
            else if (d1.value > d2.value)
              return 1;
            else
              return 0;
          });
        }
        this.blocked = false;
      },
      error => {
        this.handleError(error);
      });
  }
  checkValueForconstraintID(value: any) {
    this.enteredConstraintId = '';
    if (value === 'product') {
      this.showinputOnLoad = false;
    } else {
      this.showinputOnLoad = true;
    }
  }
  istextDisabled() {
    if (this.selectedConstraintType === 'batch' || this.selectedConstraintType === 'exclusive') {
      return false;
    } else if (this.selectedConstraintType === 'independent') {
      this.enteredConstraintId = '';
      return true;
    } else {
      return true;
    }
  }

  addToSelectedRows(data: any){
    if(!this.actionUpdateFlag){
      let index = this.setRowdataforAction.findIndex(x => x.libraryId === data.data.libraryId);
      if(index != -1) {
        this.setRowdataforAction.splice(index,1);
      }
      data.data.checkbox=true;
      this.getcheckBoxData(data.data,true);
      this.checkForAllRowselected();
    }
  }
  removeFromSelectedMap(data: any){
    if(!this.actionUpdateFlag){
      data.data.checkbox=false;
      let index = this.setRowdataforAction.findIndex(x => x.libraryId === data.data.libraryId);
      if(index != -1) {
      this.setRowdataforAction.splice(index,1);
      }
      this.isSelected = false;
    }
  }
  submitDisabledIf(){
    if ((this.enteredConstraintId && this.selectedConstraintType) || this.enteredMissingReads || (this.selectedSequencerType || this.selectedCapabilityMode || this.capabilityLength > 0)) {
      return false;
    } else if (this.selectedConstraintType === 'independent' && this.enteredConstraintId == '') {
      return false;
    } else if (this.tagCount>0 || this.untagCount>0) {
      return false;
    } else if (this.updateRawDataDeliveryDate) {
      return false;
    } else {
      return true;
    }
  }
  getLibwithProjectName(lib){
    return lib.libraryId ?  lib.libraryId+" ("+lib.projectName+")": lib;
  }

  submitUpdate(){
    let listOflibsHasNoFlowcell =[];
    let updateActionObj: RunPlanTrackLibrariesUpdateDTO = new RunPlanTrackLibrariesUpdateDTO();
    updateActionObj.actionType = this.valueToSearchforAction;
    updateActionObj.labId = this.selectedLabId;
    updateActionObj.submitConfirmed = false;

    if (this.valueToSearchforAction == UPDATE_CONSTRAINTS_OPTION) {
      let libraryIds = [];

      updateActionObj.constraintIdToBeUpdated = this.enteredConstraintId;
      updateActionObj.constraintTypeToBeUpdated = this.selectedConstraintType;
      this.listofLibrariesWithoutTruncate.forEach(library => {
        libraryIds.push(library.libraryId);
        let newHistory: TrackLibrariesUpdateHistory = {
          actioncomment: 'Library is updated with constraintType from ' + library.constraint.split(':')[0] + 'to ' + this.selectedConstraintType + ' and also updated with constraintId from' + library.constraint.split(':')[1] + ' to ' + (this.enteredConstraintId ? this.enteredConstraintId : 'no'),
          puid: this.puid, actionDate: new Date()
        };

        updateActionObj.listOfLibrariesWithValue.push({
          libraryId: library.libraryId, expressFlag: library.highPriority, actionUpdateHistory: newHistory});
      })
      updateActionObj.libraryIds = libraryIds;
    } else if (this.valueToSearchforAction == UPDATE_MISSINGREADS_OPTION) {
      updateActionObj.missingReadsToBeUpdated = this.enteredMissingReads;
      this.listofLibrariesWithoutTruncate.forEach(library => {
        let newHistory: TrackLibrariesUpdateHistory = {
          actioncomment: 'Library is updated with missingReads from ' + library.missingReads + ' to ' + this.enteredMissingReads,
          puid: this.puid, actionDate: new Date()
        };

        updateActionObj.listOfLibrariesWithValue.push({
          libraryId: library.libraryId, expressFlag: library.highPriority, actionUpdateHistory: newHistory});
      })
    } else if (this.valueToSearchforAction == UPDATE_STATUS_OPTION) {
      this.listofLibrariesWithoutTruncate.forEach(library => {
        updateActionObj.listOfLibrariesWithValue.push({
            libraryId: library.libraryId, expressFlag: library.highPriority, actionUpdateHistory: this.setHistoryForExpressStatusUpdate(library)});
      })
      
    } else if (this.valueToSearchforAction == UPDATE_SEQUENCING_STEPS_OPTION) { 
        if(this.checkforreadModevalueexists() ){
          this._messagesService.addWarningMessage({
            severity: 'error', summary: 'Read Mode empty!',
            detail: 'Please enter both read mode fields or none of the read mode fields',
          });
          return;
        } else if(this.checkforAllSpecsValue()){
          if(this.checkwithFlowcellMap()){
            this._messagesService.addWarningMessage({
              severity: 'error', summary: 'Error:',
              detail: 'Update has been rejected. The entered sequencer read mode combination is not supported by BB run planning.',
            });
            return;
            }
        }
        updateActionObj.sequencerTypeToBeUpdated = this.selectedSequencerType;
        updateActionObj.readModeToBeUpdated = this.getCapabilityMode();
        updateActionObj.readLengthToBeUpdated = this.capabilityLength;
        this.listofLibrariesWithoutTruncate.forEach(library => {
          this.validationForSequnceAndComments(library, listOflibsHasNoFlowcell);
          updateActionObj.listOfLibrariesWithValue.push({
            libraryId: library.libraryId, expressFlag: library.highPriority, actionUpdateHistory: this.frameHistoryOnDifferentCases(library)});
        })
    } else if (this.valueToSearchforAction === UPDATE_RAW_DATA_DELIVERY_DATE) {
      this.listofLibrariesWithoutTruncate.forEach(library => {
        updateActionObj.listOfLibrariesWithValue.push({
            libraryId: library.libraryId, expressFlag: library.highPriority, actionUpdateHistory: this.setHistoryForExpressStatusUpdate(library)});
      })
      updateActionObj.dueDateRawData =  this.datepipe.transform(this.updateRawDataDeliveryDate,this.dateFormatForYYYYMMDD); 
    }
    if(listOflibsHasNoFlowcell.length > 0){
      this._messagesService.addWarningMessage({
        severity: 'error', summary: 'Error:',
        detail: 'Update has been rejected. The entered values would lead to invalid sequencer - read mode combinations for the following libraries : '+listOflibsHasNoFlowcell,
      });
      return;
    }
    this.updateActionSubscription(updateActionObj);
  }

  private updateActionSubscription(updateActionObj: RunPlanTrackLibrariesUpdateDTO) {
    this.runPlantrackservice.updateActionType(updateActionObj).subscribe(
      result => {
        this.constructSuccessOrError(updateActionObj, result);
      },
      error => {
        this.handleError(error);
      });
  }

  getCapabilityMode(): string {
    return this.selectedCapabilityMode ? this.selectedCapabilityMode.name : '';
  }

  private constructSuccessOrError(updateActionObj: RunPlanTrackLibrariesUpdateDTO, result: any) {
    if (result.data.includes('tagConflicts')) {
      let message = this.createTagConflictMessage(JSON.parse(result.data));
      this.blocked = false;
      this.erroMessageAfterUpdateFailed = message;
    } else if(result.data.includes('tagLengths')){
      this.blocked = false;
      this.confirmationService.confirm({
        message: 'Attention, some of the selected libraries have tags of different tag length and will not be sequenced together as planned. Are you sure you want to proceed?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          updateActionObj.submitConfirmed = true;
          this.updateActionSubscription(updateActionObj);
        },
        reject: () => {}
      });
    } else {
      if (result.data === 'All the libraries updated successfully') {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: result.data,
          detail: '',
        });
      } else {
        this._messagesService.addSuccessMessage({
          severity: 'warn', summary: result.data,
          detail: '',
        });
      }
      this.actionUpdateFlag = false;
      this.scrollableTableColumn();
      this.onApplyFilter();
      this.listofLibrariesWithoutTruncate = [];
      this.blocked = false;
    }
  }

  createTagConflictMessage(data: any) {
    let tagConflictMap = new Map(Object.entries(data['tagConflicts']))
    let message = 'Update is failed due to <b>' + tagConflictMap.size + '</b> tag conflicts between libraries:<br>';
    if(tagConflictMap.size > 11){
      let i: number = 1;

      for(let entry of Array.from(tagConflictMap.entries())){
        let key = entry[0];
        let value = entry[1];
        if( i == 11){
          message += this.truncateStr + '<br/>';
          message += key + '(Libs: <b>' + this.getCommaSeperatedLibraryIds(value) + '</b>)';
          break;
        }
        message +=  key + '(Libs: <b>' + this.getCommaSeperatedLibraryIds(value) + '</b>)<br/>'
        i++;
      }
    } else{
      tagConflictMap.forEach((value: string[], key: string) => {
        message += key + '(Libs: <b>' + this.getCommaSeperatedLibraryIds(value) + '</b>)<br/>'
      })
    }
    return message;
  }

  getCommaSeperatedLibraryIds(value: any) {
    let commaSeperatedLibs = '';
    value.forEach(libId =>{
      commaSeperatedLibs += libId + ', ';
    })
    return commaSeperatedLibs.substring(0, commaSeperatedLibs.length - 2);
  }

  setHistoryForExpressStatusUpdate(libs: any) {
    if (libs.highPriority == 'yes') {
      return {
        actioncomment: 'Library is updated with highpriority from ' + libs.highPriority + ' to no',
        puid: this.puid, actionDate: new Date()
      };
    } else {
      return {
        actioncomment: 'Library is updated with highpriority from ' + libs.highPriority + ' to yes',
        puid: this.puid, actionDate: new Date()
      };
    }
  }

  validationForSequnceAndComments(libs: any, listOflibsHasNoFlowcell: any[]) {
    if (this.checkwithonlySequncerType()) {
        this.validatesForNoactiveSequncer(libs, listOflibsHasNoFlowcell);
    } else if (this.checkonlyWithReadModes()) {
        this.validatesForNoactiveReadModes(libs, listOflibsHasNoFlowcell);
    }
  }

  frameHistoryOnDifferentCases(libs: any) {
    if (this.checkforAllSpecsValue()) {
     return {actioncomment: 'Library is updated with sequencerType, readCharecteristics, readLength from ' +
          libs.runspecs.split(' ')[0] + ', ' + libs.runspecs.split(' ')[1] + ', ' + libs.runspecs.split(' ')[2] + ' to ' + this.selectedSequencerType + ', ' +
          this.selectedCapabilityMode.name + ', ' + this.capabilityLength + ' respectively',
        puid: this.puid, actionDate: new Date()
      };
    } else if (this.selectedSequencerType || (!this.selectedCapabilityMode && !this.capabilityLength)) {
      return {actioncomment: 'Library is updated with sequencerType from ' +
          libs.runspecs.split(' ')[0] + ' to ' + this.selectedSequencerType,
        puid: this.puid, actionDate: new Date()
      };
    } else if (!this.selectedSequencerType || (this.selectedCapabilityMode && this.capabilityLength)) {
      return {actioncomment: 'Library is updated with readCharecteristics from ' +
          libs.runspecs.split(' ')[1] + ' to ' + this.selectedCapabilityMode.name + ' and also updated with readLength from ' +
          libs.runspecs.split(' ')[2] + ' to ' + this.capabilityLength,
        puid: this.puid, actionDate: new Date()
      };
    }
  }

   validatesForNoactiveReadModes(libs: any, listOflibsHasNoFlowcell: any[]) {
    if (((this.flowCellMapwithCapabilties && this.flowCellMapwithCapabilties.get(libs.runspecs.split(' ')[0])) && !this.flowCellMapwithCapabilties.get(libs.runspecs.split(' ')[0]).includes(this.selectedCapabilityMode.name + " " + this.capabilityLength)) || (this.flowCellMapwithCapabilties && !this.flowCellMapwithCapabilties.get(libs.runspecs.split(' ')[0]))) {
      listOflibsHasNoFlowcell.push(libs.libraryId);
    }
  }

   validatesForNoactiveSequncer(libs: any, listOflibsHasNoFlowcell: any[]) {
    if ((this.flowCellMapwithCapabilties && this.flowCellMapwithCapabilties.get(this.selectedSequencerType) && !this.flowCellMapwithCapabilties.get(this.selectedSequencerType).includes(libs.runspecs.split(' ')[1] + " " + libs.runspecs.split(' ')[2])) ||
        ((this.flowCellMapwithCapabilties && !this.flowCellMapwithCapabilties.get(this.selectedSequencerType)) || (this.flowCellMapwithCapabilties && !this.flowCellMapwithCapabilties.get(libs.runspecs.split(' ')[0])))) {
      listOflibsHasNoFlowcell.push(libs.libraryId);
    }
  }

   checkonlyWithReadModes() {
    return !this.selectedSequencerType && this.selectedCapabilityMode  && this.capabilityLength;
  }

  checkwithonlySequncerType() {
    return this.selectedSequencerType && !this.selectedCapabilityMode  && !this.capabilityLength;
  }

  checkwithFlowcellMap() {
    return (this.flowCellMapwithCapabilties && !this.flowCellMapwithCapabilties.get(this.selectedSequencerType)) || (this.flowCellMapwithCapabilties && !this.flowCellMapwithCapabilties.get(this.selectedSequencerType).includes(this.selectedCapabilityMode.name + " " + this.capabilityLength));
  }

  rejectUpdate(){
    this.actionUpdateFlag=false;
    this.scrollableTableColumn();
  }

  scrollableTableColumn() {
    this.scrollableCols = [
      { 'header': 'Library Id', 'field': 'libraryId', 'selected': false },
      { 'header': 'Plate BC', 'field': 'plateBarcode', 'selected': false },
      { 'header': 'Plate Pos', 'field': 'platePosition', 'selected': false },
      { 'header': 'Sample Name', 'field': 'sampleName', 'selected': false },
      { 'header': 'Project', 'field': 'projectName', 'selected': false },
      { 'header': 'Customer', 'field': 'customer', 'selected': false },
      { 'header': 'Raw Data Due Date', 'field': 'dueDateRawData', 'selected': false },
      { 'header': 'Express', 'field': 'highPriority', 'selected': false },
      { 'header': 'Status', 'field': 'status', 'selected': false },
      { 'header': 'Constraint', 'field': 'constraint', 'selected': false },
      { 'header': 'Run - Lane', 'field': 'runLaneInfoHistory', 'selected': false },
      { 'header': 'Sequencing Specs', 'field': 'runspecs', 'selected': false },
      { 'header': 'Required Reads', 'field': 'missingReads', 'selected': false },
      { 'header': 'Select All', 'field': 'checkbox', 'selected': false }
    ];
  }

  globalFilterforTrackLib(value){
    if (value) {
      this.runTrackLibrariesPagination=this.globalFilter(this.runTrackLibrariesPaginationDuplicate, value)
    } else {
      this.runTrackLibrariesPagination =[...this.runTrackLibrariesPaginationDuplicate];
    }
  }
  globalFilter(itemList: any, searchKeyword: string) {
    let filteredList = [];
    if (itemList.length > 0) {
      searchKeyword = searchKeyword.toLowerCase();
      itemList.forEach(item => {
        let propValueList = Object.values(item);
        this.getFilteredListFromLoop(propValueList,item,searchKeyword,filteredList);
      });
      filteredList=filteredList.filter(
        (element, i) => i === filteredList.indexOf(element)
      );
    }
    return filteredList;
  }
  
  getFilteredListFromLoop(propValueList,item,searchKeyword,filteredList){
    for (var probVal of propValueList) {
      if (item.dueDateRawData) {
        let date = this.getDate(item.dueDateRawData);
        if (this.getDateCheck(date,searchKeyword)) {
          filteredList.push(item);
          break;
          }
        }
        if(this.getCheckForRunlaneInfo(item)){
          this.filterListforRunLaneInfo(item, searchKeyword, filteredList);
        }
        if (this.getCheckForProjectName(item)) {
          let customerName =this.customerNameMap.get(item.projectName);
          if (this.getCheckForCustomerName(customerName,searchKeyword)) {
            filteredList.push(item);
            break;
          }
        }
        if (this.getCheckForOtherData(probVal,searchKeyword)) {
          filteredList.push(item);
          break;
        }
      }
  }
  filterListforRunLaneInfo(item: any, searchKeyword: any, filteredList: any) {
    item.runLaneInfoHistory.forEach(runlane => {
      if (runlane != null) {
        let propValueListwithRun = Object.values(runlane);
        for (let prop of propValueListwithRun) {
          if (this.getCheckForOtherData(prop, searchKeyword)) {
            filteredList.push(item);
            break;
          }
        }
      }
    });
  }

  getCheckForRunlaneInfo(item){
    return (item.runLaneInfoHistory && item.runLaneInfoHistory.length > 0);
  }
  
  getCheckForProjectName(item){
    return (item.projectName && this.customerNameMap);
  }
  
  getDateCheck(date,searchKeyword){
    return  (date && date.toString().toLowerCase().indexOf(searchKeyword) > -1);
  }

  getCheckForCustomerName(customerName,searchKeyword){
    return (customerName && customerName.toString().toLowerCase().indexOf(searchKeyword) > -1);
  }

  getCheckForOtherData(probVal,searchKeyword){
    return (probVal && probVal.toString().toLowerCase().indexOf(searchKeyword) > -1);
  }
  
  checkBoxHighlight(row){
    if(row && row.checkbox){
      return { background : '#186ba0',color : '#FFFFFF' };
    }else{
      return { background: '#ffffff', color: '#222222'};
    }
  }

  getDisabledForAction(){
    return this.setRowdataforAction.length > 0;
  }
  getDisabledForGoButton(){
    return this.valueToSearchforAction && this.setRowdataforAction.length > 0;
  }
  abbreviateNumber(value: number) {
    let newValue = value;
    const suffixes = ["", "K", "M"];
    let suffixNum = 0;
    if (newValue >= 1000000) {
      suffixNum = 2;
      while (newValue >= 1000000) {
        newValue /= 1000000;
      }
    } else if (newValue >= 1000) {
      suffixNum = 1;
      while (newValue >= 1000) {
        newValue /= 1000;
      }
    }
    let newValueString = newValue.toFixed(1);
    if (newValueString) {
      newValueString = newValueString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    newValueString += suffixes[suffixNum];
    return newValueString;
  }

  getMapOfFlowcellWithCapabilities() {
    this.flowCellMapwithCapabilties = new Map();
    this.blocked = true;
    this.masterdataService.getMapOfFlowcellWithCapabilities(this.selectedLabId).subscribe(
      result => {
        if (result.data) {
          this.flowCellMapwithCapabilties = result.data.flowCellDurMap ? new Map(Object.entries(result.data.flowCellDurMap))  : null;
        }else{
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'No active Flowcell!',
            detail: 'Please configure active flowcell in MDM.',
          });
          return;
        }
        this.blocked = false;
      },
      error => {
        this.handleError(error);
      });
  }

  getSequencerFromMachine(){
    this.sequencerOptions =[];
    this.masterdataService.getSequencerMachines("Artic NGS").subscribe(
      result => {
        let sequenceData = result.data;
        sequenceData.forEach(seqName => {
          this.sequencerOptions.push({ label: seqName.name, value: seqName.name });
        });
      },
      error => {
        this.handleError(error);
      }
    );
  }
  checkforreadModevalueexists(){
    return (this.selectedCapabilityMode  && !this.capabilityLength) || (!this.selectedCapabilityMode && this.capabilityLength) 
  }
  checkforAllSpecsValue(){
    return this.selectedSequencerType && this.selectedCapabilityMode && this.capabilityLength;
  }
  setWidthForSideBarActivation(){
    if(!this.actionUpdateFlag){
      return { width : '100%'};
    }else{
      return { width : '66%'};
    }
  }
  sidenavClosed(){
    this.actionUpdateFlag=false;
    this.scrollableTableColumn();
  }
  isMoreButtonDisabled() {
    if(this.runTrackLibrariesValsTotalRows ) {
      return (this.runTrackLibrariesPagination.length >= this.runTrackLibrariesValsTotalRows.length) || (this.runTrackLibrariesPagination.length == 0) || (this.runTrackLibrariesValsTotalRows.length == 0) || this.actionUpdateFlag;
    } else {
      return true;
    }
  }
  moreToshow(){
    this.loading=true;
    this.runPlanTrackFilterValue ='';
      this.rowsCount +=250;
      setTimeout(() => { 
      this.runTrackLibrariesPagination=this.runTrackLibrariesValsTotalRows.slice(0,this.rowsCount );
      this.runTrackLibrariesPaginationDuplicate=this.runTrackLibrariesValsTotalRows.slice(0,this.rowsCount );
      this.loading = false; }, 50);
  }
  getRowsCount(){
    return this.runTrackLibrariesPagination.length;
  }

  getSelectedLibsInrows(){
    return this.setRowdataforAction.length;
  }

  getrowValueForRunLane(rowData: any){
    let rowResult='';
    if(rowData.runLaneInfoHistory){
      rowData.runLaneInfoHistory.sort((a, b) => {
        if (a.runId < b.runId) {
          return -1;
        }else if (a.runId > b.runId) {
          return 1;
        }
        return 0;
        })
      rowData.runLaneInfoHistory.forEach(element => {
        if(element){
          rowResult += element.runId +' - '+ element.laneId+'\n';
        }
      });
      return rowResult;
    }else{
      return '-'
    }
    
  }
}
